import { render, staticRenderFns } from "./InserimentoDati.vue?vue&type=template&id=8d4469c0&scoped=true&"
import script from "./InserimentoDati.vue?vue&type=script&lang=js&"
export * from "./InserimentoDati.vue?vue&type=script&lang=js&"
import style0 from "./InserimentoDati.vue?vue&type=style&index=0&id=8d4469c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4469c0",
  null
  
)

export default component.exports